import { RESET_LOCAL_DATA, SET_LOCAL_DATA } from "../types";

const defaultState = { settings: {}, dictionary: {} };

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case SET_LOCAL_DATA:
      let newData = { ...state };
      newData[action.payload.key] = action.payload.value;
      return { ...newData };
    case RESET_LOCAL_DATA:
      return defaultState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/local-storage-reducer.js